'use client'

import { Button } from '@yeshuman/sdk'
import type { MouseEvent } from 'react'
import { UserPlus } from 'lucide-react'


type InviteToApplyActionProps = {
  profileId: string
  isApplied: boolean
  isInvited: boolean
  isInviting: boolean
  /** Display Applied/Invited only — no invite CTA (employer Analysis tab). */
  readOnly?: boolean
  onInvite: (profileId: string) => void
}

function stopCardOpen(event: MouseEvent) {
  event.stopPropagation()
}

export function InviteToApplyAction({
  profileId,
  isApplied,
  isInvited,
  isInviting,
  readOnly = false,
  onInvite,
}: InviteToApplyActionProps) {
  if (isApplied) {
    return (
      <Button
        type="button"
        size="sm"
        variant="successMuted"
        disabled
        onClick={stopCardOpen}
      >
        <UserPlus className="mr-1.5 shrink-0" aria-hidden />
        Applied
      </Button>
    )
  }

  if (isInvited) {
    return (
      <Button
        type="button"
        size="sm"
        variant="secondary"
        disabled
        onClick={stopCardOpen}
      >
        <UserPlus className="mr-1.5 shrink-0" aria-hidden />
        Invited
      </Button>
    )
  }

  if (readOnly) {
    return null
  }

  return (
    <Button
      type="button"
      size="sm"
      variant="outline"
      disabled={isInviting}
      onClick={(event) => {
        stopCardOpen(event)
        onInvite(profileId)
      }}
    >
      <UserPlus className="mr-1.5 shrink-0" aria-hidden />
      {isInviting ? 'Inviting…' : 'Invite'}
    </Button>
  )
}
